module.exports = "/img/logo.svg?b5435e5ef17fc44baec7300d31d71f18";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/img/identity/logo.svg
// module id = keC5
// module chunks = 54